const coloredWidgets = [
  'c-widget--editorial-feed',
  'c-widget--editorial-slider',
  'c-widget--listing',
  'c-widget--fact-card',
  'c-widget--big-text-section',
  'c-widget--partner-box',
  'c-yumpu'
]

const widgetFooterAdjustment = () => {

  const lastWidget = document.querySelector('main .c-widget:last-child');
  if(lastWidget) {
    if(lastWidget.classList.contains('c-widget--big-text-section') || lastWidget.classList.contains('c-yumpu') || lastWidget.classList.contains('c-widget--fact-card-full') || lastWidget.classList.contains('c-widget--theme-red-900') || lastWidget.classList.contains('c-widget--theme-red-100') || lastWidget.classList.contains('c-widget--theme-blue-900') || lastWidget.classList.contains('c-widget--theme-blue-100') ||lastWidget.classList.contains('c-widget--theme-warm-grey-100')) {
      coloredWidgets.forEach(widget => {
        if(lastWidget.classList.contains(widget)) {
          document.querySelector('main').classList.add('is-colored-last-widget');
        }
      })
    }
  }
}

widgetFooterAdjustment();

const widgetHeaderAdjustment = () => {

  const firstWidget = document.querySelector('main .c-widget:first-child');

  if(firstWidget) {
    if(firstWidget.classList.contains('c-widget--big-text-section') || firstWidget.classList.contains('c-yumpu') || firstWidget.classList.contains('c-widget--fact-card-full') || firstWidget.classList.contains('c-widget--theme-red-900') || firstWidget.classList.contains('c-widget--theme-red-100') || firstWidget.classList.contains('c-widget--theme-blue-900') || firstWidget.classList.contains('c-widget--theme-blue-100') ||firstWidget.classList.contains('c-widget--theme-warm-grey-100')) {
      coloredWidgets.forEach(widget => {
        if(firstWidget.classList.contains(widget)) {
          document.querySelector('main').classList.add('is-colored-first-widget');
        }
      })
    }
  }
}

widgetHeaderAdjustment();
